import React from "react"

import TodoModal from "../../student/activity/todo/TodoModal"
import { findItemInListWithId } from "@data/utility/dataUtils"

/**
 * An activity already in the todo opens the real TodoModal on its persisted
 * Activity — the tutor's usual gesture, with the student object that carries
 * `todo_activities` so the modal's "activity still exists?" guard has
 * something to read.
 *
 * L'écran ne porte que `preview` : la résolution de l'élève et de l'activité
 * vit ici, avec la modale qu'elle sert.
 */
const ExistingActivityModal = ({
    preview,
    students,
    tutorStudentsById,
    schoolSubjects,
    navigation,
    onClose,
}) => {
    if (!preview) return null

    const previewStudent = students.find(
        (s) => s.student_id === preview.studentId
    )
    if (!previewStudent) return null

    const tutorStudent = tutorStudentsById?.[preview.studentId]
    const activity = (tutorStudent?.todo_activities ?? []).find(
        (a) => a?.id === preview.activityId
    )
    if (!activity) return null

    return (
        <TodoModal
            isOpen
            handleShowModal={onClose}
            onExit={onClose}
            onRequestClose={onClose}
            item={activity}
            studentId={preview.studentId}
            student={tutorStudent}
            schoolSubject={findItemInListWithId(
                activity?.school_subject_id,
                schoolSubjects
            )}
            navigation={navigation}
        />
    )
}

export default ExistingActivityModal
